import React, { useState, useEffect } from 'react'
import { Input, InputGroup, InputLeftAddon, Select } from '@chakra-ui/react'
import countryCodes from '../../utils/country_codes.json'

export default function PhoneInput ({ value, onChange, isWhatsapp }) {
  const [code, setCode] = useState('GB')
  const [phoneNumber, setPhoneNumber] = useState('')

  useEffect(() => {
    if (value) {
      const val = isWhatsapp ? value.replace('whatsapp:', '') : value
      // Sort country codes by length in descending order
      const sortedCountryCodes = countryCodes.sort((a, b) => b.dial_code.length - a.dial_code.length)
      let matchedCode = null
      let number = val

      // Check against each country code
      for (const country of sortedCountryCodes) {
        if (val.startsWith(country.dial_code)) {
          matchedCode = country.dial_code
          number = val.replace(matchedCode, '').trim()
          setCode(country.code)
          break
        }
      }

      if (matchedCode) {
        setPhoneNumber(number)
      }
    }
  }, [value])

  const localOnChange = function (dialCode, number) {
    const selectedCountry = countryCodes.find(c => c.code === dialCode)
    if (!dialCode || !number?.length) onChange('')
    else onChange(`${isWhatsapp ? 'whatsapp:' : ''}${selectedCountry?.dial_code || ''}${number}`)
    setCode(dialCode)
    setPhoneNumber(number)
  }

  return (
    <InputGroup>
      <InputLeftAddon>
        <Select size='sm' maxW='200px' variant='unstyled' value={code} onChange={e => localOnChange(e.target.value, phoneNumber)}>
          {countryCodes.map(country =>
            <option key={country.code} value={country.code}>
              {country.dial_code} ({country.name})
            </option>
          )}
        </Select>
      </InputLeftAddon>
      <Input
        bg='white' type='text' placeholder='7123456789' value={phoneNumber} onChange={e => {
          localOnChange(code, e.target.value?.replace(/[^0-9]/, ''))
        }}
      />
    </InputGroup>
  )
}
